export * from './crm-find-tariffs.response.dto';

export * from './crm-patch-tariff.request.dto';
export * from './crm-patch-tariff.response.dto';

export * from './crm-create-tariff.request.dto';
export * from './crm-create-tariff.response.dto';
